import { useContext } from "react";
import { ChordContext } from "../contexts/chord-context";
import Chord from "@tombatossals/react-chords/lib/Chord";
import { guitarInstrument } from "../utils/chord-lookup";

const ChordDiagram = () => {
  const { chordData, chordNotFound } = useContext(ChordContext);

  if (chordNotFound || !chordData) {
    return <p className="no-result-text">No diagram available for this combination</p>;
  }

  return <Chord chord={chordData} instrument={guitarInstrument} />;
};

export default ChordDiagram;
